import React from "react";
import PropTypes from 'prop-types';
import "./avatar.scss";
function URAvaratSkeleton(props: any) {
  let {className } = props;
  return (
    <>
      <div className={className}><div className="statusDot"></div></div>
    </>

  );
}

export {
  URAvaratSkeleton
};

URAvaratSkeleton.propTypes = {
  className: PropTypes.any
};